import { render, staticRenderFns } from "./CheckboxContact.vue?vue&type=template&id=02d71c2a&"
import script from "./CheckboxContact.vue?vue&type=script&lang=ts&"
export * from "./CheckboxContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports